import React from 'react';
import { Heading } from '../../components/Heading';
import TermsOfUseContent from './TermsOfUseContent';

const TermsOfUse: React.FC = () => (
  <div className="max-w-xl-content mx-auto mb-7 w-full flex-row px-4 pt-6 md:mb-9 md:px-6 md:pt-7">
    <Heading level="h1" text="PRINCIPAL PORTAL TERMS OF USE" />
    <TermsOfUseContent headingLevel="h2" />
  </div>
);

export default TermsOfUse;
